export default "__VITE_ASSET__CeXy0h6N__"